module.exports = __webpack_public_path__ + "static/ikhuoriah-40040f9b84ff7d0455a85c4420237406.png";